import { render, staticRenderFns } from "./UpdateTechnicalDevicePage.vue?vue&type=template&id=3b68c310"
import script from "./UpdateTechnicalDevicePage.vue?vue&type=script&lang=js"
export * from "./UpdateTechnicalDevicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports